'use strict'

// import { request } from 'https';
import Joi from 'joi-browser';
import React from 'react';
import { alertActions } from '../common';
import { EntityActions } from '../common/base/entity';
import ToastMessage from '../common/base/entity/components/Toast';
import { getExactError } from '../common/base/entity/joiErrorWrapper';
// import {EntityComponent} from '../entity'

export class userQueueAction extends EntityActions {
    constructor(options) {
        super(options);
    }
    upsertItem({ entityValues, tenantId }) {
        let that = this
        return dispatch => {
          dispatch(that.request({ method: 'EDIT' }))
          // @ts-ignore
          if (that.preActionsHooks) {
            // @ts-ignore
            entityValues = that.preActionsHooks({ actionName: 'upsertItem', item: entityValues, tenantId: tenantId, propFields: that.propFields })
          }
          if (!entityValues.userNames || entityValues.userNames.length === 0) {
            dispatch(that.failure({ method: 'EDIT', errorMsg: 'User Name is Required' }))
            dispatch(alertActions.error(<ToastMessage messages={'User Name is Required'} />))
            return
          }
          if (that.methodSchemas && that.methodSchemas.upsert) {
            let val = Joi.validate(entityValues, that.methodSchemas.upsert, { abortEarly: false })
            if (val.error) {
              let errorMsg = getExactError(val.error) //`Request did not pass the joi schema validation, ${val.error.message}`;
              dispatch(that.failure({ method: 'EDIT', errorMsg }))
              dispatch(alertActions.error(<ToastMessage messages={errorMsg} />))
              return
            }
          }
          that.service
            .upsertRecord({ item: entityValues, tenantId })
            .then(item => {
              if (item) {
                // @ts-ignore
                let itemData =  item && item.data || item
                console.log("data", itemData)
                if (that.postActionsHooks) item = that.postActionsHooks({ actionName: 'editItem', item: (itemData && itemData[0]) || itemData })
    
                // @ts-ignore
                dispatch(that.success({ method: 'EDIT', item: itemData }))
                dispatch(alertActions.success(that.resourceName + ' updated successfully'))
                if(item.nonSsoUsers && item.nonSsoUsers.pop && item.nonSsoUsers.length>0){
                dispatch(alertActions.info(`We have added the mentioned ${item.nonSsoUsers.map(c=>c.email).join(', ')} in User queue but not in team queue ${itemData.queueName}.`))
                setTimeout(function () {
                  that.goBackUrl(entityValues.configType)
                }, 5000)
                }
                else{
                setTimeout(function () {
                    that.goBackUrl(entityValues.configType)
                }, 1000)
                }
              } else {
                let errorMsg = 'Cannot update the ' + that.resourceName + ' at this moment please try again later'
                dispatch(that.failure({ method: 'EDIT', errorMsg }))
                dispatch(alertActions.error(errorMsg))
              }
            })
            .catch(error => {
              let errorMsg =
                error && error.details
                  ? getExactError(error)
                  : `Could not insert/update the  ${that.resourceName} at this moment. ${(error && error.message) || error || 'Please try again later.'}`
              dispatch(that.failure({ method: 'EDIT', errorMsg }))
              dispatch(alertActions.error(<ToastMessage messages={errorMsg} />))
            })
        }
    }
}